import { trackClickEvent } from './';

export const trackCovidInfoClicked = (cardIndex: number) => {
  trackClickEvent(`mob_rail_landing_covid_card_clicked_position_${cardIndex}`);
};
